import { useSearchParams } from "react-router";

import { Grid, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading } from "capitalrx-components-2.0/lib/typography";

import { Card } from "@/premium/themedComponents";

import "./PharmacyDetailsPage.scss";
import { useTranslation } from "react-i18next";

const TRANSLATION_PATH = "PHARMACY_DETAILS_PAGE";

export const PrescriptionDetailsPanel = () => {
  const { t: translate } = useTranslation();

  const { halfColumns } = useResponsive({
    halfColumns: { desktop: 6, tablet: 6, mobile: 12 },
  });

  const [searchParams] = useSearchParams();
  const days_supply = +searchParams.get("daysSupply");
  const dosage = searchParams.get("dosage");
  const quantity = +searchParams.get("quantity");
  const dosage_form = searchParams.get("dosageForm");
  const drug_name = searchParams.get("drugName");
  const drug_type = searchParams.get("drugType");

  return (
    <Stack>
      <Heading>{translate(`${TRANSLATION_PATH}.prescriptionDetails`)}</Heading>
      <Card className="card">
        <Grid>
          <Grid.Span columns={halfColumns}>
            <Stack>
              <Stack spacing="mini">
                <Body className="detail-label">{translate(`${TRANSLATION_PATH}.drugName`)}</Body>
                <Body>{drug_name || "--"}</Body>
              </Stack>
              <Stack spacing="mini">
                <Body className="detail-label">{translate(`${TRANSLATION_PATH}.quantity`)}</Body>
                <Body>{quantity || "--"}</Body>
              </Stack>
              <Stack spacing="mini">
                <Body className="detail-label">{translate(`${TRANSLATION_PATH}.dosage`)}</Body>
                <Body>{dosage || "--"}</Body>
              </Stack>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={halfColumns}>
            <Stack>
              <Stack spacing="mini">
                <Body className="detail-label">{translate(`${TRANSLATION_PATH}.type`)}</Body>
                <Body>{drug_type || "--"}</Body>
              </Stack>
              <Stack spacing="mini">
                <Body className="detail-label">{translate(`${TRANSLATION_PATH}.daysSupply`)}</Body>
                <Body>{days_supply || "--"}</Body>
              </Stack>
              <Stack spacing="mini">
                <Body className="detail-label">{translate(`${TRANSLATION_PATH}.form`)}</Body>
                <Body>{dosage_form || "--"}</Body>
              </Stack>
            </Stack>
          </Grid.Span>
        </Grid>
      </Card>
    </Stack>
  );
};
